<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon">
		</header-layout>
		<div class="container mt-n15">
			<div class="datatable">
				<datatable-type :instanceClassAttr="instanceClassAttr" />
			</div>
		</div>
	</div>
</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableType from '@/components/templates/datatables/DatatableType.vue';
	import {MAP_ALL_ATTRS_SEC} from '@/modules/typeadmin/details/sec-attrs';
	import {MAP_ALL_ATTRS_PRS} from '@/modules/typeadmin/details/prs-attrs';
	import {MAP_ALL_ATTRS_SERV} from '@/modules/typeadmin/details/serv-attrs';
	import {MAP_ALL_ATTRS_MVT} from '@/modules/typeadmin/details/mvt-attrs';
	import {MAP_ALL_ATTRS_REP} from '@/modules/typeadmin/details/rep-attrs';
	// import {MAP_ALL_ATTRS_NOT} from '@/modules/typeadmin/details/not-attrs';

	

	
	export default {
		name: 'TypesAdmin',
		props:['type'],
		components: {
			'datatable-type': DatatableType,
			'header-layout': Header
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t(this.type+'.all'),
				pageTitle: this.$t(this.type+'.list'),
				pageIcon: 'user',
				instanceClassAttr: {
					actCol: {actDisplay: true, thCol: '10%', actAdd: true, actGet: true, actEdit: true, actDel: true},
					instanceClass: this.type,
					attrsList: []	
				}
			}  
		},
		created() {
			let MAP_ALL_ATTRS = {}

			for (let key in MAP_ALL_ATTRS_SEC) {
				MAP_ALL_ATTRS[key] = MAP_ALL_ATTRS_SEC[key]
			}
			for (let key in MAP_ALL_ATTRS_PRS) {
				MAP_ALL_ATTRS[key] = MAP_ALL_ATTRS_PRS[key]
			}
			for (let key in MAP_ALL_ATTRS_SERV) {
				MAP_ALL_ATTRS[key] = MAP_ALL_ATTRS_SERV[key]
			}
			for (let key in MAP_ALL_ATTRS_MVT) {
				MAP_ALL_ATTRS[key] = MAP_ALL_ATTRS_MVT[key]
			}

			for (let key in MAP_ALL_ATTRS_REP) {
				MAP_ALL_ATTRS[key] = MAP_ALL_ATTRS_REP[key]
			}
			/*for (let key in MAP_ALL_ATTRS_NOT) {
				MAP_ALL_ATTRS[key] = MAP_ALL_ATTRS_NOT[key]
			}*/
			

			this.pageIcon = MAP_ALL_ATTRS[this.type].iconClass
			this.instanceClassAttr.attrsList = MAP_ALL_ATTRS[this.type].attrsList
			// si actCol not default
			if( MAP_ALL_ATTRS[this.type].actCol)
				this.instanceClassAttr.actCol = MAP_ALL_ATTRS[this.type].actCol
		},
	}
</script>